<template>
  <div class="error">
    <div class="errorimg"></div>
    <div class="errortext">登录出错.....</div>
    <a class="fanhui" @click="clickLeft">返回</a>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    clickLeft() {
        this.$router.push({ path: '/login'});
    }
  },
  watch: {
    
  }
}
</script>

<style scoped lang="scss">
.error{
    height: 100vh;
    .errorimg {
        width: 98px;
        height: 64px;
        position: absolute;
        top: 20%;
        left: 50%;
        transform: translate(-50%, 0);
        background: url('./../../assets/error.png') ;
        background-size: cover;
    }
    .errortext {
        text-align: center;
        position: absolute;
        top: 30%;
        width: 100%;
        color:rgb(138, 150, 163)
    }
    .fanhui {
        text-align: center;
        position: absolute;
        font-size: px2rem(64);
        top: 40%;
        width: 100%;
        color:rgb(12, 5, 217)
    }
}
</style>
